export function isProviderPdfExpected(document) {
  return Boolean(document?.external_id || document?.raw_data?.external_id);
}

export function shouldRefreshPdfOnOpen(document) {
  return Boolean(document?.id && (document.pdf_url || isProviderPdfExpected(document)));
}
